import { createTheme, type ThemeOptions } from '@mui/material';
import { commonThemeBase as common } from '../common.theme.base';
import { componentOverrides } from './component.overrides';

const darkTableThemeBase = {
  ...common,

  palette: {
    mode: 'dark',

    common: common.config.colors,

    text: {
      primary: common.config.colors.darkGreySoft,
    },

    background: {
      default: common.config.colors.darkGrey,
      paper: common.config.colors.darkGreyLighter,
      lighter: common.config.colors.darkGreyLighter,
      tableHeader: common.config.colors.blueGrey,
      tableRowHover: common.config.colors.darkGreyActive,
      tableRow: common.config.colors.darkGreyLighter,
      tableBody: common.config.colors.darkGrey,
    },

    border: {
      menuItem: common.config.colors.white,
    },

    button: {
      disabledBackground: common.config.colors.grey8,
    },

    components: {
      globalHeader: {
        contrastText: common.config.colors.white,
      },
    },

    error: {
      main: common.config.colors.error,
      dark: common.config.colors.ripeTomato,
    },

    graphs: {
      pie: {
        primaryBlue: common.config.colors.cowbellLight,
        secondaryBlue: common.config.colors.powderBlue,
        primaryGreen: common.config.colors.cowbellAccent,
        secondaryGreen: common.config.colors.cowbellGreen,
      },
    },

    primary: {
      main: common.config.colors.white,
      green: common.config.colors.good,
      yellow: common.config.colors.elevated,
      red: common.config.colors.critical,
      grey: common.config.colors.greyWhite,
    },

    tables: {
      productRow: common.config.colors.tableRowDark,
    },

    jsonPalette: {
      base00: common.config.colors.darkGreyActive, // background
      base01: 'red',
      base02: common.config.colors.darkGreySoft,
      base03: common.config.colors.darkGreySoft,
      base04: common.config.colors.darkGreySoft,
      base05: '#444',
      base06: '#444',
      base07: common.config.colors.darkGreySoft,
      base08: '#444',
      base09: common.config.colors.darkGreySoft,
      base0A: common.config.colors.darkGreySoft,
      base0B: common.config.colors.darkGreySoft,
      base0C: common.config.colors.darkGreySoft,
      base0D: common.config.colors.darkGreySoft,
      base0E: common.config.colors.darkGreySoft,
      base0F: common.config.colors.darkGreySoft,
    },
  },
} as Partial<ThemeOptions>;

const themedComponentOverrides = componentOverrides(darkTableThemeBase);

export const darkTableTheme = createTheme({
  ...darkTableThemeBase,
  ...themedComponentOverrides,
});
